export default "__VITE_ASSET__Oqi57ePg__"